export type Result<T, E = Error> = { ok: true; value: T } | { ok: false; error: E };

type Truthy<T> = T extends false | '' | 0 | null | undefined ? never : T;
export function truthy<T>(value: T): value is Truthy<T> {
	return !!value;
}
